export function convertEmployeeCompetencies(inputObject: {
  [key: string]: string;
}): { id: number; level: string }[] {
  return Object.entries(inputObject).map(([key, value]) => {
    return { id: parseInt(key), level: value };
  });
}
